import { RunwayModelsResponse, TimelineEvent } from '@/types';

export const UPDATE_TIMELINE_EVENTS = 'UPDATE_TIMELINE_EVENTS';

export const INSERT_TIMELINE_EVENT = 'INSERT_TIMELINE_EVENT';

export interface TryUpdateTimelineEventsAction {
    type: typeof UPDATE_TIMELINE_EVENTS;
    payload: RunwayModelsResponse['timelineEvents'];
}

export interface TryInsertTimelineEventAction {
    type: typeof INSERT_TIMELINE_EVENT;
    payload: TimelineEvent;
}

export const updateTimelineEvents = (
    payload: RunwayModelsResponse['timelineEvents'],
): TryUpdateTimelineEventsAction => {
    return {
        type: UPDATE_TIMELINE_EVENTS,
        payload: payload,
    };
};

// Insert event at the beginning of the array to respect timeline order
export const insertTimelineEvent = (payload: TimelineEvent): TryInsertTimelineEventAction => {
    return {
        type: INSERT_TIMELINE_EVENT,
        payload: payload,
    };
};
